import { render } from "./social.vue?vue&type=template&id=d16cf47a"
import script from "./social.vue?vue&type=script&lang=js"
export * from "./social.vue?vue&type=script&lang=js"
script.render = render

export default script